
import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import {
  updateOpenDeviceSearchDialog,
  updateSelectedDeviceForSleep
} from "actions/settings";

import {
  InputAdornment,
  SvgIcon,
  Box,
  Button,
  TextField,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import PerfectScrollbar from 'react-perfect-scrollbar';
import SearchIcon from '@material-ui/icons/Search';
import { SIREN_CONFIG } from 'config.js';
import { FormattedMessage, useIntl } from "react-intl";



const COLUMN_WIDTH = {
  // NO: '3%',
  SENSOR_ID: '20%',
  SERIAL_NO: '10%',
  ROOM_NAME: '20%', //28
  INSTALL_DETAIL: '10%', //34
  ROOM_TYPE: '10%', //40
  WAKEUP: '8%', //45
  ISACTIVE: '8%', //50
  IS_TARGET_TO_SLEEP_ANALYSIS: '14%', //56
}



/**
 * 센서 검색 다이어로그 창
 * @param {*} props 
 * @returns 
 */
const DeviceSearchDialog = (props) => {

  const classes = useStyles();
  const { formatMessage } = useIntl();

  const [listData, setListData] = useState([]);
  const selector_openDialog = useSelector((state) => state.envSettings.openDeviceSearchDialog);
  const selector_whichDevice = useSelector((state) => state.envSettings.whichDevice); //수면 디바이스 구분자: 0...n

  const selector_selected_devices = useSelector((state) => state.envSettings.selected_device_for_sleep);

  const [queryDeviceID, setQueryDeviceID] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);


  const closeDialog = () => {
    props.updateOpenDeviceSearchDialog(false);
  }

  const handleChangeDeviceIDInput = (event) => {
     event.persist();
     setQueryDeviceID(event.target.value);
  }

  const selectDevice = (event, module) => {
    let newlist = selector_selected_devices;

    newlist[selector_whichDevice] = {
      idx: selector_whichDevice,
      deviceId: module.deviceId,
      label: module.roomName + '_' + module.installed_pos_detail
    };

    props.updateSelectedDeviceForSleep(newlist);
    closeDialog();
  }


  const handleDeviceSearch = (event) => {
    searchDeviceData(queryDeviceID);
  }


  const searchDeviceData = (sensorId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/device/v2/deviceList?`;

    var params = '';
    if (sensorId) {
      params = 'deviceId=' + sensorId;
    }

    url += params;

    fetch(url)
      .then(res => res.json())
      .then(snapshot => {
        var list = [];
        var idx = 1;
        if (snapshot.resultData != null) {
          snapshot.resultData.forEach(doc => {
            doc.no = idx++;
            list.push(doc);
          });
        }
        setListData(list);
      });
  }

  const doKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      handleStationSearch();
    }
  }

  // useEffect(() => {
  //   console.log('selector_whichDevice: ', selector_whichDevice);
  // }, [selector_whichDevice]);


  const startRow = (page * rowsPerPage);


  return (
    <div className={classes.root}>

      <Dialog open={selector_openDialog ?? false} onClose={() => { closeDialog }}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle align="center"><Typography variant="h3">{formatMessage({ id: 'search_sensor' })}</Typography></DialogTitle>
        <DialogContent>

          <Box m={1} p={1}>
            <Box
              mt={2}
              display="flex"
              alignItems="between"
              justifyContent="start"
              flexGrow={1}
            >

              <TextField
                className={classes.queryField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                }}
                onChange={handleChangeDeviceIDInput}
                label={formatMessage({ id: 'device_sensor_id' })}
                placeholder={formatMessage({ id: 'device_sensor_id' })}
                value={queryDeviceID}
                variant="outlined"
                onKeyPress={(ev) => doKeyPress(ev)}
              />

              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.bulkAction}
                onClick={handleDeviceSearch}
              >
                {formatMessage({ id: 'search' })}
              </Button>
            </Box>
          </Box>

          <Box m={1} p={1}>
            <PerfectScrollbar>
              <div className={classes.inner}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell width={COLUMN_WIDTH.SENSOR_ID} align="center">{formatMessage({ id: 'device_sensor_id' })}</TableCell>
                      <TableCell width={COLUMN_WIDTH.SERIAL_NO} align="center">SerialNo</TableCell>
                      <TableCell width={COLUMN_WIDTH.ROOM_NAME} align="center">{formatMessage({ id: 'room_name'})}</TableCell>
                      <TableCell width={COLUMN_WIDTH.INSTALL_DETAIL} align="center">{formatMessage({ id: 'room_position'})}</TableCell>
                      <TableCell width={COLUMN_WIDTH.WAKEUP} align="center">{formatMessage({ id: 'wakeup'})}</TableCell>
                      <TableCell width={COLUMN_WIDTH.ISACTIVE} align="center">{formatMessage({ id: 'activation'})}</TableCell>
                      <TableCell width={COLUMN_WIDTH.IS_TARGET_TO_SLEEP_ANALYSIS} align="center">{formatMessage({ id: 'sleepAnalysis'})}</TableCell>
                      <TableCell width={COLUMN_WIDTH.TIME} align="center">{formatMessage({ id: 'device_last_time'})}</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {listData.slice(0 + startRow, rowsPerPage + (page * rowsPerPage)).map(module => (
                      <TableRow
                        hover
                        className={classes.tableRow}
                        key={module.statId}
                        onClick={(event) => selectDevice(event, module)}
                      >
                        <TableCell width={COLUMN_WIDTH.SENSOR_ID}><Typography variant="body1">{module.deviceId}</Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.SERIAL_NO}><Typography variant="body1">{module.serialProduct}</Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.ROOM_NAME}><Typography variant="body2">{module.roomName}</Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.INSTALL_DETAIL}><Typography variant="body2">{module.installed_pos_detail}</Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.WAKEUP}>
                          <Typography variant="body1">
                          {module.wakeUpDetect == 1 ? formatMessage({id:'wakeup'}) : '-'}
                          </Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.ISACTIVE}>
                          <Typography variant="body2">
                            {module.isActive == 1 ? formatMessage({id:'active'}) : formatMessage({id:'inactive'})}
                          </Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.IS_TARGET_TO_SLEEP_ANALYSIS}>
                          <Typography variant="body2">
                            {module.isTargetToSleepAnalysis == 1 ? formatMessage({id:'active'}) : formatMessage({id:'inactive'})}
                          </Typography></TableCell>
                        <TableCell width={COLUMN_WIDTH.TIME}><Typography variant="body2">{module.businessTel}</Typography></TableCell>
                      </TableRow>
                    ))}

                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={() => { closeDialog() }}>{formatMessage({id:'close'})}</Button>
        </DialogActions>
      </Dialog>
    </div>

  )

};



const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateOpenDeviceSearchDialog,

    updateSelectedDeviceForSleep,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    envSettings: state.envSettings,
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceSearchDialog);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  queryField: {
    flexBasis: 220,
    marginRight: 20,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },

  divider: {
    margin: theme.spacing(2, 0)
  },
}));


